import { REHYDRATE } from 'redux-persist';

import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { ApiResult } from '@crema/models/Apps';
import { axiosBaseQuery } from './baseQuery';

const CHANNEL_PRODUCT_URL = '/api/channel-product-assortment';
const DEFAULT_ROWS_PER_PAGE = 100;

export const channelProductAssortmentApi = createApi({
  reducerPath: 'channelProductAssortment.api',
  baseQuery: axiosBaseQuery,
  extractRehydrationInfo(action, { reducerPath }) {
    if (action.type === REHYDRATE) {
      return action.payload?.[reducerPath];
    }
  },
  tagTypes: ['channelProductAssortments'],
  endpoints: (builder) => ({
    getChannelProductAssortments: builder.query({
      query: ({
        pageNo = 0,
        pageSize = DEFAULT_ROWS_PER_PAGE,
        name = '',
        category = '',
        subCategory = '',
        unpaged = false,
      }) => ({
        url: encodeURI(
          `${CHANNEL_PRODUCT_URL}?pageNo=${pageNo}&pageSize=${pageSize}&name=${name}&category=${category}&subCategory=${subCategory}&unpaged=${unpaged}`,
        ),
      }),
      transformResponse: (response, meta: any) => {
        return {
          rows: response,
          totalCount: meta.totalCount,
        } as ApiResult;
      },
      keepUnusedDataFor: 5,
      providesTags: ['channelProductAssortments'],
    }),
    getChannelProductAssortmentById: builder.query({
      query: (id) => ({ url: `${CHANNEL_PRODUCT_URL}/${id}` }),
      providesTags: ['channelProductAssortments'],
    }),
    getChannelProductAssortmentDetailInfo: builder.query({
      query: (id) => ({ url: `${CHANNEL_PRODUCT_URL}/${id}/full-info` }),
      providesTags: ['channelProductAssortments'],
    }),
    getChannelProductAssortmentOptionVarianPricing: builder.query({
      query: (id) => ({ url: `${CHANNEL_PRODUCT_URL}/${id}/option-variant-pricing` }),
      providesTags: ['channelProductAssortments'],
    }),
    addChannelProductAssortment: builder.mutation({
      query: (body) => ({
        url: `${CHANNEL_PRODUCT_URL}`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['channelProductAssortments'],
    }),
    deleteChannelProductAssortment: builder.mutation({
      query: (id) => ({
        url: `${CHANNEL_PRODUCT_URL}/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['channelProductAssortments'],
    }),
    updateChannelProductAssortment: builder.mutation({
      query: (data) => ({
        url: `${CHANNEL_PRODUCT_URL}/${data.id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['channelProductAssortments'],
    }),
  }),
});

export const {
  useGetChannelProductAssortmentsQuery,
  useGetChannelProductAssortmentByIdQuery,
  useGetChannelProductAssortmentDetailInfoQuery,
  useGetChannelProductAssortmentOptionVarianPricingQuery,

  useAddChannelProductAssortmentMutation,
  useUpdateChannelProductAssortmentMutation,
  useDeleteChannelProductAssortmentMutation,
} = channelProductAssortmentApi;
